<template>
	<c-dialog ref="dialog" mask-close mode="slide" width="1000" enable-flex>
		<!-- 表单区域 -->
		<c-form ref="form" column="2" vertical unit-width="100%">
            <!--送修人不作选择：谁操作送修谁就是送修人，且只能是商品的当前接驳人（下表「当前接驳人」列可见）-->
            <c-form-item label="维修单位" required>
                <c-input name="repair_unit" v-model="formData.repair_unit" placeholder="请输入"></c-input>
            </c-form-item>
            <c-form-item label="送修时间" required>
                <c-datetime name="delivery_date" v-model="formData.delivery_date"></c-datetime>
            </c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark" v-model="formData.remark" placeholder="请输入" maxlength="200"></c-input>
			</c-form-item>

			<c-title>送修商品明细</c-title>
			<c-form-item :label="false" colspan="2">
				<m-operate border v-if="!disabled">
					<c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanHandle(false)" @blur="scanHandle(true)">
                        <template #appendIcon><i class="tf-scan"></i></template>
					</c-input>
					<c-button color="main" @click="scanHandle(false)">确定</c-button>
					<c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
				</m-operate>
				<!-- 已扫码列表 -->
				<c-table ref="list" :data="scannedList" border @dataChange="selectChange">
					<template #empty>
						<c-empty message="请扫描产品背贴码"></c-empty>
					</template>

					<c-table-column type="selector" width="32"></c-table-column>
					<c-table-column label="产品信息" width="300">
						<template #default="{data}">
                            <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                            {{getProductText(data)}}
                        </template>
					</c-table-column>
					<c-table-column label="背贴码" width="150">
						<template #default="{data}">{{data.produce_unique_code}}</template>
					</c-table-column>
					<c-table-column label="IMEI" width="160">
						<template #default="{data}">{{data.produce_imei || '-'}}</template>
					</c-table-column>
					<c-table-column label="采购价" width="80">
						<template #default="{data}">{{data.purchase_price ? '￥' + data.purchase_price : '-'}}</template>
					</c-table-column>
					<c-table-column label="当前接驳人" width="100">
						<template #default="{data}">{{data.handler_user_name || '-'}}</template>
					</c-table-column>
					<c-table-column label="操作" width="80" type="button">
						<template #default="{data}">
							<c-table-button v-if="!disabled" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="dialog" color="main" :disabled="!scannedList.length" @click="submitHandle">确认送修</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
export default {
	name: 'repairDeliveryDialog',

	props: {
		productData: {
			type: Object,
			default: () => ({})
		},
		// 编辑模式时传入的送修记录数据
		editData: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			formData: {
				repair_unit: '',
				delivery_date: '',
				remark: ''
			},
			scanCode: '',
			scannedList: [],
			queryingCode: '',
            disabled: false,
			selectedList: []
		}
	},

	methods: {
		/*********打开弹框**********/
		open(data) {
            this.disabled = false
			this.formData = {
				repair_unit: '',
				delivery_date: '',
				remark: ''
			};
			this.scannedList = [];
			this.selectedList = [];
			this.scanCode = '';
			this.queryingCode = '';

			if (this.editData) {
				// 编辑模式：加载送修记录详情
				this.loadDeliveryDetail(this.editData.id || this.editData.delivery_id);
			} else if (this.productData && this.productData.produce_unique_code) {
				// 新建模式：自动填入背贴码并查询
				this.scanCode = this.productData.produce_unique_code;
				this.scanHandle(false);
                this.disabled = true;
			}

			this.$refs.dialog.open({title: this.editData ? '编辑送修记录' : '送修'});
			this.focusInput();
		},

		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********加载送修记录详情（编辑模式）**********/
		loadDeliveryDetail(deliveryId) {
			var self = this;
			this.request({
				url: '/repair/delivery/detail',
				data: {id: deliveryId},
				success: function(data) {
					var delivery = data.delivery || data;
					var details = data.details || [];
					self.formData.repair_unit = delivery.repair_unit || '';
					self.formData.delivery_date = delivery.delivery_date || '';
					self.formData.remark = delivery.remark || '';
					// 填充已有明细
					details.forEach(function(d) {
						self.scannedList.push({
							_detail_id: d.id,
							produce_unique_code: delivery.produce_unique_code || '',
							produce_unique_code_id: delivery.produce_unique_code_id,
							repair_item: d.repair_item,
							repair_amount: d.repair_amount
						});
					});
				}
			});
		},

		/*********聚焦输入框**********/
		focusInput() {
			this.$nextTick(() => {
				var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
				if (input) input.focus();
			});
		},

		/*********扫码处理**********/
		// silentWhenEmpty: true=失焦触发（空值静默），false=回车/确定按钮触发（空值提示）
		scanHandle(silentWhenEmpty) {
			var code = this.scanCode.trim();
			if (!code) {
				if (!silentWhenEmpty) {
					this.$message({message: '请输入背贴码', type: 'warn'});
				}
				return;
			}
			// 同码请求进行中不重复查询（避免失焦后点确定/回车的双触发导致重复入列）
			if (code === this.queryingCode) {
				return;
			}
			if (this.scannedList.some(item => item.produce_unique_code == code)) {
				this.$message({message: '该背贴码已扫描', type: 'warn'});
				this.scanCode = '';
				this.focusInput();
				return;
			}
			this.queryingCode = code;
			this.request({
				url: '/repair/product/queryByCode',
				data: {
					produce_unique_code: code
				},
				success: (data) => {
					this.scannedList.push(data);
					this.scanCode = '';
					this.queryingCode = '';
					this.focusInput();
				},
				fail: (msg) => {
					this.$message({message: msg, type: 'warn'});
					this.scanCode = '';
					this.queryingCode = '';
					this.focusInput();
				}
			});
		},

		/*********扫码处理**********/
		selectChange() {
			this.selectedList = this.$refs.list.getData('selected');
		},

		/*********选中变化**********/
		removeItem(data) {
			this.scannedList = this.scannedList.filter(item => item.produce_unique_code_id != data.produce_unique_code_id);
			this.focusInput();
		},

		/*********批量移除选中项**********/
		batchRemove() {
			if (!this.selectedList.length) {
				this.$message({message: '请先勾选要移除的记录', type: 'warn'});
				return;
			}
			var ids = this.selectedList.map(item => item.produce_unique_code_id);
			this.scannedList = this.scannedList.filter(item => !ids.includes(item.produce_unique_code_id));
			this.selectedList = [];
			this.focusInput();
		},

		/*********提交送修**********/
		submitHandle() {
			if (!this.scannedList.length) {
				this.$message({message: '请扫描至少一个产品', type: 'warn'});
				return;
			}
			if (!this.formData.repair_unit) {
				this.$message({message: '请输入维修单位', type: 'warn'});
				return;
			}
			if (!this.formData.delivery_date) {
				this.$message({message: '请选择送修时间', type: 'warn'});
				return;
			}

			this.$confirm({
				message: '确认送修' + this.scannedList.length + '条记录吗？',
				cancelButton: true,
				resolve: () => {
					this.submitDelivery();
				}
			});
		},

		/*********执行提交**********/
		submitDelivery() {
			if (this.editData) {
				// 编辑模式：更新主表 + 整体替换明细
				var self = this;
				var deliveryId = this.editData.id || this.editData.delivery_id;
				
				// 1. 更新送修记录主表
				this.request({
					url: '/repair/delivery/edit',
					data: {
						id: deliveryId,
						repair_unit: this.formData.repair_unit,
						delivery_date: this.formData.delivery_date,
						remark: this.formData.remark
					},
					loading: true,
					success: function() {
						// 2. 整体替换明细
						var items = self.scannedList.map(function(item) {
							return {
								repair_item: item.repair_item || 0,
								repair_amount: item.repair_amount || 0
							};
						});
						
						if (items.length === 0) {
							self.$message({message: '保存成功', type: 'success'});
							self.$emit('resolve');
							self.$refs.dialog.close();
							return;
						}
						
						self.request({
							url: '/repair/delivery/detail/edit',
							data: {
								id: deliveryId,
								items: JSON.stringify(items)
							},
							loading: false,
							success: function() {
								self.$message({message: '保存成功', type: 'success'});
								self.$emit('resolve');
								self.$refs.dialog.close();
							},
							fail: function(msg) {
								self.$message({message: msg, type: 'error'});
							}
						});
					},
					fail: function(msg) {
						self.$message({message: msg, type: 'error'});
					}
				});
			} else {
				// 新建模式：批量添加送修记录（多个商品各创建一条），送修人由服务端按当前登录人记录
				var products = this.scannedList.map(function(item) {
					return {
						produce_unique_code_id: item.produce_unique_code_id,
						/**回传背贴码，供后端拦截提示定位到具体商品*/
						produce_unique_code: item.produce_unique_code || ''
					};
				});
				
				this.request({
					url: '/repair/delivery/batchAdd',
					data: {
						repair_unit: this.formData.repair_unit,
						products: JSON.stringify(products),
						delivery_date: this.formData.delivery_date,
						remark: this.formData.remark
					},
					loading: true,
					success: () => {
						this.$message({message: '送修成功', type: 'success'});
						this.scannedList = [];
						this.$emit('resolve');
						this.$refs.dialog.close();
					},
					fail: (msg) => {
						this.$message({message: msg, type: 'error'});
					}
				});
			}
		},

		/*********关闭弹框**********/
		closeDialog() {
			this.$refs.dialog.close();
		}
	}
}
</script>

<style lang="stylus" scoped>
.form-row
	display flex
	gap 16px
	>>> .c-form-item
		flex 1

.detail-card
	border 1px solid #e8e8e8
	border-radius 4px
	overflow hidden
	flex-grow 1
	display flex
	flex-direction column
	> .c-title
		padding 10px 16px
		margin 0
		border-bottom 1px solid #e8e8e8
	.toolbar
		padding 10px 16px
		margin 0
		> * + *
			margin-left 8px
		.scan-input
			position relative
			width 220px

.empty-state
	padding 40px 0
	text-align center
	color #999
	p
		margin-top 10px
		font-size 14px

.stat-area
	padding 10px 0
	text-align left
	color #666
	font-size 14px
	b
		color #1890ff
</style>
